import ScheduleHeader from "./ScheduleHeader";

export default ScheduleHeader;